<template>
  <div>
    <b-slider
      :value="rayon"
      :min="constantes.rayonMin"
      :max="constantes.rayonMax"
      :step="constantes.rayonStep"
      :custom-formatter="(val) => val + 'km'"
      @change="rayon = $event"
      tooltip/>
    <div class="pt-20">
      <concurrent-collapse
        v-for="secteur in getConcurrents"
        :key="secteur.id"
        :donnee="secteur"
        @check="actionCheckSecteur(secteur)"
        class-libelle="has-text-weight-bold"
        :default-open="secteur.openSecteur">
        <concurrent-collapse
          v-for="(marque, index) in secteur.children"
          :key="index"
          :donnee="marque"
          @check="actionCheckMarque(marque, secteur)"
          @archive="openPopUpPrevention(marque)">
          <concurrent-collapse
            v-for="pdv in marque.children ? marque.children : []"
            :key="pdv.id"
            :donnee="pdv"
            @check="actionCheckPdv(marque, secteur)"
            @archive="openPopUpPrevention(pdv)">
          </concurrent-collapse>
        </concurrent-collapse>
      </concurrent-collapse>
    </div>
    <modal-prevention
      :modal-is-active="modalIsActive"
      :message="$t('concurrent.modalConfirmation.message')"
      :libelle-btn-valide="$t('concurrent.modalConfirmation.libelleBtnValide')"
      :libelle-btn-cancel="$t('concurrent.modalConfirmation.libellebtnCancel')"
      @modalIsClose="modalIsActive = $event"
      @isValide="achiverConcurrent"
      type="is-confirmation"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import * as Config from '@/configuration/configurationCarte';
import * as types from '@/store/creationRecommandation/pointDeVente-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import ConcurrentCollapse from '@/components/recommandation/concurrent/concurrentCollapse';
import ModalPrevention from '@/components/general/modal.vue';
import { ArchiverClient } from '@/api/clients';

const Parametres = createNamespacedHelpers('parametrage');
const PointDeVente = createNamespacedHelpers('pointDeVente');

export default {
  components: {
    ConcurrentCollapse,
    ModalPrevention,
  },
  data() {
    return {
      constantes: {
        rayonMin: Config.RAYON_MIN,
        rayonMax: Config.RAYON_MAX,
        rayonStep: Config.RAYON_STEP,
      },
      openSecteur: true,
      selected: false,
      modalIsActive: false,
      concurrentAArchiver: null,
    };
  },
  computed: {
    ...PointDeVente.mapGetters({
      getRayon: 'rayon',
      getLastRayon: 'lastRayon',
      getConcurrents: 'concurrents',
    }),
    rayon: {
      get() {
        return this.getRayon;
      },
      set(value) {
        this.setFilterRayon(value);
        this.loadConcurrents();
      },
    },
  },
  methods: {
    ...PointDeVente.mapMutations({
      setFilterRayon: types.SET_FILTER_RAYON,
      setLastRayon: types.SET_LAST_RAYON,
    }),
    ...PointDeVente.mapActions({
      actionsRecupererConcurrents: 'recupererConcurrents',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async loadConcurrents() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionsRecupererConcurrents();
      } catch (error) {
        gestionErreur('Erreur lors de la récupération des concurrents', error);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
    actionCheckSecteur(secteur) {
      secteur.children.forEach(marque => {
        marque.selected = secteur.selected;
        marque.children.forEach(el => {
          el.selected = marque.selected;
        });
      });
    },
    actionCheckMarque(marque, secteur) {
      marque.children.forEach(el => {
        el.selected = marque.selected;
      });
      secteur.selected = secteur.children.every(el => el.selected);
    },
    actionCheckPdv(marque, secteur) {
      marque.selected = marque.children.every(el => el.selected);
      secteur.selected = secteur.children.every(el => el.selected);
    },
    async achiverConcurrent() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await ArchiverClient(this.concurrentAArchiver.id);
        this.modalIsActive = false;
        this.concurrentAArchiver = null;
        this.$buefy.toast.open({
          message: this.$t('concurrent.modalConfirmation.msgSuccess'),
          type: 'is-success',
        });
        this.loadConcurrents();
      } catch (error) {
        gestionErreur('Erreur lors de l\'archivage du concurrent', error);
      } finally {
        loadingComponent.close();
      }
    },
    openPopUpPrevention(pdv) {
      this.concurrentAArchiver = pdv;
      this.modalIsActive = true;
    }
  },
  async mounted() {
    if (this.getLastRayon) {
      this.rayon = this.getLastRayon;
      this.setLastRayon(null);
    }
    else this.rayon = Config.RAYON_DEFAULT;
    await this.loadParametres([PARAMETRES_KEYS.secteurActivite, PARAMETRES_KEYS.marque]);
    await this.loadConcurrents();
  },
};
</script>
